
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { BookingConfigItemProps } from "./";
import { AppMessage } from "components";

interface ApiBookingConfigInputProps {
    fromDate: string;
    toDate: string;
    timeFrameIds: number[]
}

type ApiBookingConfigOutputProps = OutputBaseProps<BookingConfigItemProps[]>;

export const apiBookingConfigIndex = async (data: ApiBookingConfigInputProps) => {
    const res = (await axios.post<ApiBookingConfigOutputProps>("/api/booking/config", data))
        .data;
    return res;
};

export const apiBookingConfigSave = async (data: BookingConfigItemProps & { appliesToAll?: boolean }) => {
    const res = (await axios.post<ApiBookingConfigOutputProps>("/api/booking/config/save", data))
        .data;
    if (res.status) {
        AppMessage.success({
            title: "Thành công",
            message: res.message
        })
    }
    return res;
};

interface ApiBookingConfigRemoveInputProps {
    dates: string[];
    timeFrameIds: number[];
}
export const apiBookingConfigRemove = async (data: ApiBookingConfigRemoveInputProps) => {
    const res = (await axios.delete<ApiBookingConfigOutputProps>("/api/booking/config/remove", { data }))
        .data;
    if (res.status) {
        AppMessage.success({
            title: "Thành công",
            message: res.message
        })
    }
    return res;
};